export default __webpack_public_path__ + "static/media/Artboard 35.52659ed5.png";